export default "__VITE_ASSET__kGAqLwLv__"